var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleCheckmarkGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3589_4726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6192 75H34.3294C33.0288 74.8018 31.7282 74.6402 30.435 74.3905C11.279 70.7187 -1.9619 52.7931 0.235118 33.4354C1.15361 25.3427 4.28381 18.1607 9.89026 12.2565C19.5454 2.08562 31.471 -2.01209 45.1749 0.932683C60.385 4.20792 69.952 13.8647 74.0521 28.8824C74.5518 30.7183 74.7355 32.6129 75 34.4929V40.6321C74.8236 41.8364 74.662 43.0408 74.4636 44.2378C72.0682 58.5431 60.6055 70.704 46.4387 74.016C44.5136 74.464 42.5664 74.7283 40.6118 75H40.6192ZM5.96648 37.5918C5.87096 54.8566 20.0891 69.1472 37.5551 69.1472C54.9696 69.1472 69.1437 54.8933 69.1511 37.5698C69.1511 20.1729 54.8888 5.94835 37.5037 5.97772C20.17 6.0071 5.84891 20.2096 5.96648 37.5918Z",
    fill: "#00FF3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7864 50.825C31.3903 51.0893 30.413 50.4798 29.5092 49.5545C27.224 47.2193 24.8874 44.9354 22.5949 42.6222C21.2428 41.2563 21.3384 39.2368 22.7712 38.1279C23.9836 37.1953 25.5634 37.2907 26.7611 38.4363C28.3409 39.9565 29.8766 41.528 31.427 43.0701C32.348 43.9856 33.2714 43.9832 34.1972 43.0628C39.4877 37.7754 44.7782 32.4954 50.0613 27.2007C50.9798 26.2754 51.9938 25.7173 53.3311 26.1065C55.4253 26.716 56.1748 29.1981 54.7566 30.8651C54.5509 31.1074 54.3231 31.3204 54.0953 31.5481C48.1509 37.489 42.1991 43.4226 36.2693 49.3856C35.2773 50.3843 34.256 51.1628 32.7864 50.8396V50.825Z",
    fill: "#00FF3C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3589_4726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheckmarkGreen);
export default __webpack_public_path__ + "static/media/circle-checkmark-green.d3fe9bfcf3ad533ed0ce44f43567b0f1.svg";
export { ForwardRef as ReactComponent };